import { useCallback, useMemo } from 'react'
import { SortItem } from '../../../../components/data-grid/filters/sort'
import { GetApiKeysSortEnum } from '../../../../generated/graphql'
import { GridSortDirection, GridSortModel } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'

type GridSortItem = GridSortModel[number]['field']

export const useSortItems = () => {
  const { t } = useTranslation(['api_keys'])
  const sortItems = useMemo<SortItem<GetApiKeysSortEnum>[]>(
    () => [
      {
        field: 'username',
        sort: 'asc',
        title: t('api_keys:id'),
        type: 'number',
        value: GetApiKeysSortEnum.Id,
        isDefault: true,
      },
      {
        field: 'username',
        sort: 'desc',
        title: t('api_keys:id'),
        type: 'number',
        value: GetApiKeysSortEnum.Id2,
      },
      {
        field: 'name',
        sort: 'asc',
        title: t('api_keys:name'),
        type: 'text',
        value: GetApiKeysSortEnum.Name,
      },
      {
        field: 'name',
        sort: 'desc',
        title: t('api_keys:name'),
        type: 'text',
        value: GetApiKeysSortEnum.Name2,
      },
      {
        field: 'last_used',
        sort: 'asc',
        title: t('api_keys:last_used'),
        type: 'date',
        value: GetApiKeysSortEnum.LastUsed,
      },
      {
        field: 'last_used',
        sort: 'desc',
        title: t('api_keys:last_used'),
        type: 'date',
        value: GetApiKeysSortEnum.LastUsed2,
      },
    ],
    [t],
  )

  const getSort = useCallback(
    (sortModel: GridSortModel) => {
      const getSortItem = (
        field: GridSortItem,
        sort: GridSortDirection,
      ): SortItem<GetApiKeysSortEnum> | undefined => {
        return sortItems.find(
          (item) => item.field === field && item.sort === sort,
        )
      }

      if (!sortModel || sortModel.length === 0 || !sortModel[0]) return null
      const sortItem = sortModel[0]

      const { field, sort } = sortItem
      return getSortItem(field, sort)
    },
    [sortItems],
  )

  return { sortItems, getSort }
}
